import { Component, OnInit } from '@angular/core';
import { ApplicationInfoService, BreadcrumbEventService, SdkDictionaryService } from '@dsivd/prestations-ng';

@Component({
    templateUrl: './page-wrapper.component.html'
})
export class PageWrapperComponent implements OnInit {

    appTitle: string;
    etapeId: string;

    constructor(
        private dictionaryService: SdkDictionaryService,
        private applicationInfoService: ApplicationInfoService,
        private breadcrumbService: BreadcrumbEventService
    ) {
    }

    ngOnInit(): void {
        this.applicationInfoService.firstEtapeInfo.subscribe(etapeInfo => {
            const { titreEtape, idMetierPrestation, idMetierEtape } = etapeInfo;

            this.breadcrumbService.setConfiguration({
                prestationCode: idMetierPrestation
            });

            this.appTitle = titreEtape;
            this.etapeId = idMetierEtape;
        });
    }
}
